<template>
    <div>
        <form role="form" method="POST" @submit.prevent="validateAndLogin()" novalidate @keydown="errors.remove('generic')">

            <label>
                <input type="email" v-model="form.email" name="email" v-validate="'required|email'" placeholder="E-pasts"/>
                <span class="form-error is-visible" v-if="errors.has('email')">{{ errors.first('email') }}</span>
            </label>

            <label>
                <input type="password" v-model="form.password" name="password" v-validate="'required'" placeholder="Parole"/>
                <span class="form-error is-visible" v-if="errors.has('password')">{{ errors.first('password') }}</span>
            </label>

            <span class="form-error is-visible" v-if="errors.has('generic')">{{ errors.first('generic') }}</span>

            <div class="note clearfix">
                <div class="float-left">
                    <label for="remember" class="label-light">
                        <input type="checkbox" v-model="form.remember" id="remember"/>Atcerēties mani
                    </label>
                </div>
                <a class="float-right" href="#" v-open-in-reveal="emailReveal" @click.prevent>Aizmirsi paroli?</a>
            </div>

            <div class="text-center">
                <input class="large primary button" type="submit" value="Ienākt" :disabled="errors.any()"/>
            </div>

        </form>
    </div>
</template>

<script>
    import OpenInReveal from '../../directives/OpenInReveal'
    import EmailReveal from './EmailReveal'
    import { Form } from '../../modules/forms/Form'
    import auth from '../../api/auth'

    export default  {

        data() {
            return {
                form: new Form({
                    email: '',
                    password: '',
                    remember: false
                }),

                emailReveal: EmailReveal
            }
        },

        methods: {

            validateAndLogin: function () {
                this.$validator.validateAll()
                    .then(result => { if (result) this.login() })
            },

            login: function () {

                const credentials = {
                    username: this.form.email,
                    password: this.form.password,
                };

                auth.login(credentials)
                    .then(response => {
                        console.log("Logged in on LoginForm");
                        this.$emit('login')
                        this.$store.dispatch('login', response.data, this.form.remember)

                        if (this.$router.currentRoute.query.intended) {
                            this.$router.push(this.$router.currentRoute.query.intended)
                        } else {
                            this.$router.push({ name: 'home' })
                        }
                    }, response => this.renderServerErrors(response.data))
                    .catch(error => this.renderServerErrors(error.response.data));
            },

            renderServerErrors: function (errors) {
                // Register form wide error
                if (errors.hasOwnProperty('error') && errors.hasOwnProperty('message')) {
                    let message;

                    switch (errors.error) {
                        case 'invalid_credentials':
                            message = 'Lietotāja epasts un/vai parole norādīta nepareizi'
                            break;
                        case 'unsupported_grant_type':
                            message ='Nederīgs autentifikācijas veids.'
                            break;
                        case 'invalid_request':
                        case 'invalid_grant':
                        case 'invalid_scope':
                        case 'invalid_client':
                            message ='Nederīgs pieprasījums.'
                            break;
                        case 'access_denied':
                            message = 'Pieeja bloķēta'
                            break;
                        case 'server_error':
                            message = 'Servera kļūda'
                            break;
                        default:
                            message = errors.message;
                    }

                    this.errors.add('generic', message, 'auth')
                }

                // Record errors for available fields only
                for (let field in errors) {
                    if (!errors.hasOwnProperty(field)) continue;

                    if (this.form.hasOwnProperty(field)) {
                        this.errors.add(field, errors[field], 'auth')
                    }
                }
            }
        },

        directives: {
            'open-in-reveal': OpenInReveal
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/settings";
    @import "../../../sass/mixins";

    .note {
        font-size: px-em(11px);

        label {
            font-size: inherit;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/LoginForm.vue